import { createContext, useContext } from 'react';

export interface IPanelDetailsContext {
    source?: 'All' | 'Filtered';
}

export const PanelDetailsContext = createContext<IPanelDetailsContext>({ source: 'All' });
export const usePanelDetailsContext = () => useContext(PanelDetailsContext);
